// types
import type { Components, Theme } from "@mui/material";

export const MuiCssBaseline: Components<Theme>["MuiCssBaseline"] = {
  styleOverrides: (theme) => ({
    "*, *::before, *::after": {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
    },
    html: {
      width: "100%",
      height: "100%",
      WebkitOverflowScrolling: "touch",
      scrollBehavior: "smooth",
    },
    body: {
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.background.default,
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      textRendering: "optimizeLegibility",
    },
    "::-webkit-scrollbar": {
      width: 5,
      height: 5,
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.12)"
          : "rgba(0,0,0,0.08)",
      borderRadius: 3,
    },
    "::-webkit-scrollbar-thumb:hover": {
      background:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.2)"
          : "rgba(0,0,0,0.15)",
    },
    "::selection": {
      background: theme.palette.primary.main,
      color: "#fff",
    },
  }),
};
